import './index.scss';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import usePrevious from '~/hooks/usePrevious';
import ErrorPage from './error_page';
const ErrorRoute = ({ error, info }) => {
    const location = useLocation();
    const locationState = location.state;
    const prevLocation = usePrevious(location);
    const prevLocationState = prevLocation === null || prevLocation === void 0 ? void 0 : prevLocation.state;
    const [activeLocationState, setActiveLocationState] = useState(locationState);
    useEffect(() => {
        setActiveLocationState(prevLocationState || locationState);
    }, [prevLocationState, locationState]);
    error = (activeLocationState === null || activeLocationState === void 0 ? void 0 : activeLocationState.error) || error;
    info = (activeLocationState === null || activeLocationState === void 0 ? void 0 : activeLocationState.info) || info;
    return (React.createElement(ErrorPage, { error: error, info: info }));
};
export default ErrorRoute;
